module.exports = __webpack_public_path__ + "9fc223108b90d78b5401e123a29b5b36.svg";